import { GameMap } from "../games";

export default [
  { 
    name: 'start',
    title: 'Introduction',
    collection: ''
  },
  { 
    name: 'r1m1',
    title: 'Deviant\'s Domain',
    collection: 'Episode 1'
  },
  { 
    name: 'r1m2',
    title: 'Dread Portal',
    collection: 'Episode 1'
  },
  { 
    name: 'r1m3',
    title: 'Judgment Call',
    collection: 'Episode 1'
  },
  { 
    name: 'r1m4',
    title: 'Cave of Death',
    collection: 'Episode 1'
  },
  { 
    name: 'r1m5',
    title: 'Towers of Wrath',
    collection: 'Episode 1'
  },
  { 
    name: 'r1m6',
    title: 'Temple of Pain',
    collection: 'Episode 1'
  },
  { 
    name: 'r1m7',
    title: 'Tomb of the Overlord',
    collection: 'Episode 1'
  },
  { 
    name: 'r2m1',
    title: 'Tempus Fugit',
    collection: 'Episode 2'
  },
  { 
    name: 'r2m2',
    title: 'Elemental Fury I',
    collection: 'Episode 2'
  },
  { 
    name: 'r2m3',
    title: 'Elemental Fury II',
    collection: 'Episode 2'
  },
  { 
    name: 'r2m4',
    title: 'Curse of Osiris',
    collection: 'Episode 2'
  },
  { 
    name: 'r2m5',
    title: 'Wizard\'s Keep',
    collection: 'Episode 2'
  },
  { 
    name: 'r2m6',
    title: 'Blood Sacrifice',
    collection: 'Episode 2'
  },
  { 
    name: 'r2m7',
    title: 'Last Bastion',
    collection: 'Episode 2'
  },
  { 
    name: 'r2m8',
    title: 'Source of Evil',
    collection: 'Episode 2'
  },
] as GameMap[]
